import React from "react";
import "./CardComponent.scss";
import ButtonComponent from "../ButtonComponent/ButtonComponent";

const CardComponent = ({
  title = "Vishmi & Sanjana",
  date = "December 18, 2025",
  time = "Ceremony • 9:00 AM — 3:30 PM  |  Poruwa • 9.15:00 AM",
  venueName = "The Kingsbury",
  venueAddress = "48 Janadhipathi Mawatha, Colombo",
  mapsQuery,
  variant = "light", // "light" | "dark"
}) => {
  const q = encodeURIComponent(mapsQuery || `${venueName}, ${venueAddress}`);
  const mapsLink = `https://www.google.com/maps/search/?api=1&query=${q}`;
  const mapsEmbedSrc = `https://www.google.com/maps?q=${q}&z=15&output=embed`;

  const CalendarIcon = (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <rect x="3" y="4" width="18" height="17" rx="3"></rect>
      <path d="M8 2v4M16 2v4M3 10h18"></path>
    </svg>
  );
  const ClockIcon = (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <circle cx="12" cy="12" r="9"></circle>
      <path d="M12 7v5l3 2"></path>
    </svg>
  );
  const PinIcon = (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M12 22s7-5.1 7-12a7 7 0 1 0-14 0c0 6.9 7 12 7 12z"></path>
      <circle cx="12" cy="10" r="2.5"></circle>
    </svg>
  );

  const InfoRow = ({ icon, label, children }) => (
    <div className="ccard__row">
      <div className="ccard__head">
        <span className="ccard__headIcon">{icon}</span>
        <span className="ccard__headLabel">{label}</span>
      </div>
      <div className="ccard__value">{children}</div>
    </div>
  );

  return (
    <div className={`ccard ${variant === "dark" ? "ccard--dark" : ""}`}>
      <div className="ccard__ribbon" aria-hidden />
      <div className="ccard__inner">
        <div className="ccard__content">
          {/* <h2 className="ccard__title">{title}</h2> */}

          <div className="ccard__rows">
            <InfoRow icon={CalendarIcon} label="DATE">
              {date}
            </InfoRow>

            <InfoRow icon={ClockIcon} label="TIME">
              {time}
            </InfoRow>

            <InfoRow icon={PinIcon} label="VENUE">
              {venueName}
              <br />
              <span className="ccard__muted">{venueAddress}</span>
            </InfoRow>
          </div>

          {/* <div className="ccard__actions">
            <ButtonComponent as="a" href={mapsLink} target="_blank" rel="noopener noreferrer">
              Open in Google Maps
            </ButtonComponent>
          </div> */}
        </div>

        {/* <div className="ccard__map">
          <div className="ccard__mapFrame">
            <iframe
              title="Venue map"
              src={mapsEmbedSrc}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default CardComponent;
